var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUp = function SvgArrowUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.5 486.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 5.2 9 179.1c-5.1 5.1-7.9 11.8-7.9 19s2.8 14 7.9 19l10.1 10.1c5.1 5.1 11.8 7.9 19 7.9s14.2-2.8 19.3-7.9l109.3-105.3.6 344.2c0 10.7 8.7 19.4 19.4 19.4h27.1c11.2 0 20.4-9.2 20.4-20.4V121.6l110.5 105.7c5.1 5.1 11.7 7.9 18.9 7.9s13.9-2.8 18.9-7.9l10.1-10.2c5.1-5.1 7.8-11.8 7.8-19s-2.8-14-7.9-19L210.6 5.7C205.5.6 203.1 0 200.1 0c-3-.1-4.6.1-9.6 5.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export default ForwardRef;